import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { ProviderGroupSpot, ProviderGroupSpotDto } from "../../../models/provider-parking/provider-group-spot.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperProviderGroupService } from '../../../mappers/provider-parking/mapper-provider-group-spot.service';

@Injectable({
    providedIn: 'root',
})
export class ApiProviderGroupSpotService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapperProviderGroupService: MapperProviderGroupService
    ) { }



    /**
     * ดึงข้อมูลรายการกลุ่มจุดให้บริการ
     */
    getProviderGroup(): Observable<ProviderGroupSpot[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ProviderGroupSpotDto[]>(
            '/backoffice/GetProviderGroup',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetProviderGroup',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapperProviderGroupService.mapProviderGroupFromDto(dto)))
        );
    }

    /**
     * สร้างหรือแก้ไขข้อมูลกลุ่มจุดให้บริการ
     */
    createProviderGroup(payload: ProviderGroupSpot): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapperProviderGroupService.mapProviderGroupToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateProviderGroup',
            'POST',
            this.baseUrl,
            {
                labelLog: 'CreateProviderGroup',
                token: token,
                headerOnly: false,
                isConsoleLog: true,
                body: dto
            }
        );
    }
}
